'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _users = require('./users/users');

var _users2 = _interopRequireDefault(_users);

var _profiles = require('./profiles/profiles');

var _profiles2 = _interopRequireDefault(_profiles);

var _userDetails = require('./user-details/user-details');

var _userDetails2 = _interopRequireDefault(_userDetails);

var _jobDetails = require('./job-details/job-details');

var _jobDetails2 = _interopRequireDefault(_jobDetails);

var _login = require('./login/login');

var _login2 = _interopRequireDefault(_login);

var _certificates = require('./certificates/certificates');

var _certificates2 = _interopRequireDefault(_certificates);

var _checks = require('./checks/checks');

var _checks2 = _interopRequireDefault(_checks);

var _media = require('./media/media');

var _media2 = _interopRequireDefault(_media);

var _survey = require('./survey/survey');

var _survey2 = _interopRequireDefault(_survey);

var _affiliates = require('./affiliates/affiliates');

var _affiliates2 = _interopRequireDefault(_affiliates);

var _vouches = require('./vouches/vouches');

var _vouches2 = _interopRequireDefault(_vouches);

var _analytics = require('./analytics/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _jobs = require('./jobs/jobs');

var _jobs2 = _interopRequireDefault(_jobs);

var _flow = require('./flow/flow');

var _flow2 = _interopRequireDefault(_flow);

var _botFlow = require('./bot-flow/bot-flow');

var _botFlow2 = _interopRequireDefault(_botFlow);

var _botSessions = require('./bot-sessions/bot-sessions');

var _botSessions2 = _interopRequireDefault(_botSessions);

var _botSessionDetails = require('./bot-session-details/bot-session-details');

var _botSessionDetails2 = _interopRequireDefault(_botSessionDetails);

var _botManager = require('./bot-manager/bot-manager');

var _botManager2 = _interopRequireDefault(_botManager);

var _analyticsRevenue = require('./analytics-revenue/analytics-revenue');

var _analyticsRevenue2 = _interopRequireDefault(_analyticsRevenue);

var _analyticsUsers = require('./analytics-users/analytics-users');

var _analyticsUsers2 = _interopRequireDefault(_analyticsUsers);

var _analyticsTraffic = require('./analytics-traffic/analytics-traffic');

var _analyticsTraffic2 = _interopRequireDefault(_analyticsTraffic);

var _analyticsData = require('./analytics-data/analytics-data');

var _analyticsData2 = _interopRequireDefault(_analyticsData);

var _analyticsBot = require('./analytics-bot/analytics-bot');

var _analyticsBot2 = _interopRequireDefault(_analyticsBot);

var _analyticsMarketing = require('./analytics-marketing/analytics-marketing');

var _analyticsMarketing2 = _interopRequireDefault(_analyticsMarketing);

var _businesses = require('./businesses/businesses');

var _businesses2 = _interopRequireDefault(_businesses);

var _businessDetails = require('./business-details/business-details');

var _businessDetails2 = _interopRequireDefault(_businessDetails);

var _jobRequests = require('./job-requests/job-requests');

var _jobRequests2 = _interopRequireDefault(_jobRequests);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContainersModule = _angular2.default.module('app.containers', [_users2.default.name, _profiles2.default.name, _userDetails2.default.name, _jobDetails2.default.name, _login2.default.name, _certificates2.default.name, _checks2.default.name, _media2.default.name, _survey2.default.name, _affiliates2.default.name, _vouches2.default.name, _analytics2.default.name, _jobs2.default.name, _flow2.default.name, _botFlow2.default.name, _botSessions2.default.name, _botManager2.default.name, _botSessionDetails2.default.name, _analyticsRevenue2.default.name, _analyticsUsers2.default.name, _analyticsTraffic2.default.name, _analyticsData2.default.name, _analyticsBot2.default.name, _analyticsMarketing2.default.name, _businesses2.default.name, _businessDetails2.default.name, _jobRequests2.default.name]);

exports.default = ContainersModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/containers.js
 **/